// features/classSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  classId: null,
  classData: null, // Store the form data here
};

const classSlice = createSlice({
  name: "class",
  initialState,
  reducers: {
    setClassId: (state, action) => {
      state.classId = action.payload;
    },
    setClassData: (state, action) => {
      state.classData = action.payload;
    },
    clearClassData: (state) => {
      state.classId = null;
      state.classData = null;
    },
  },
});

export const { setClassId, setClassData, clearClassData } = classSlice.actions;
export default classSlice.reducer;